import React from 'react';
import { Grid, CardMedia } from '@mui/material';
import { useStaticValues } from '@stateManagement/StaticValuesContext';
import { Text } from '@web-for-marketing/react-ui';
import { SuccessStoriesTranslation } from '@models/successStory';
import { ClientProfileModel } from 'models/successStory';

interface ClientProfileProps {
    clientProfile: ClientProfileModel;
    successStoriesTranslation: SuccessStoriesTranslation;
}

const classes = {
    mediaContainer: {
        marginBottom: '3rem',
        display: 'flex',
        width: 'fit-content',
    },
    gridItem: {
        marginBottom: '3rem',
    },
    media: {
        maxHeight: '64px',
        objectFit: 'contain',
    },
} as const;

export function ClientProfile({ clientProfile, successStoriesTranslation }: ClientProfileProps): JSX.Element {
    const { prefixStringWithBaseUrl } = useStaticValues();
    const clientFleetFocus = clientProfile?.fleetFocus;

    return (
        <>
            {clientProfile ? (
                <Grid>
                    {clientProfile.imageUrl ? (
                        <Grid css={classes.mediaContainer}>
                            <CardMedia
                                image={prefixStringWithBaseUrl(clientProfile.imageUrl)}
                                css={classes.media}
                                component='img'
                                alt={clientProfile.imageAlt}
                            />
                        </Grid>
                    ) : null}
                    <Grid css={classes.gridItem}>
                        <Text weight='medium' color='tertiary'>
                            {successStoriesTranslation.name}:
                        </Text>
                        <Text color='tertiary'>{clientProfile.name}</Text>
                    </Grid>
                    <Grid css={classes.gridItem}>
                        <Text weight='medium' color='tertiary'>
                            {successStoriesTranslation.industry}:
                        </Text>
                        <Text color='tertiary'>{clientProfile.industry}</Text>
                    </Grid>
                    <Grid css={classes.gridItem}>
                        <Text weight='medium' color='tertiary'>
                            {successStoriesTranslation.typesOfVehicles}:
                        </Text>
                        <Text color='tertiary'>{clientProfile.vehicleTypes}</Text>
                    </Grid>
                    {clientProfile.fleetSize ? (
                        <Grid css={classes.gridItem}>
                            <Text weight='medium' color='tertiary'>
                                {successStoriesTranslation.fleetSize}:
                            </Text>
                            <Text color='tertiary'>{clientProfile.fleetSize}</Text>
                        </Grid>
                    ) : null}
                    {clientFleetFocus && clientFleetFocus.length ? (
                        <Grid css={classes.gridItem}>
                            <Text weight='medium' color='tertiary'>
                                {successStoriesTranslation.fleetFocus}:
                            </Text>
                            <Text color='tertiary'>
                                {clientFleetFocus.map((item, index) => {
                                    return (
                                        <span key={index}>
                                            {item.name}
                                            <>{index < clientFleetFocus.length - 1 ? <span>,&nbsp;</span> : null}</>
                                        </span>
                                    );
                                })}
                            </Text>
                        </Grid>
                    ) : null}
                </Grid>
            ) : null}
        </>
    );
}
